import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getCmsPages } from "@/features/shop/cms/services/cms.service";
import type { CmsPage } from "@/features/shop/cms/types/cms.types";

export const CMS_PAGES_QUERY_KEY = ["cmsPages"] as const;

type UseCmsPagesQueryProps = {
  enabled: boolean
  accessToken: string | null
  onGetCmsPagesSuccess: () => void
  onGetCmsPagesError: () => void
};

export const useCmsPagesQuery = ({
  enabled,
  accessToken,
  onGetCmsPagesSuccess,
  onGetCmsPagesError,
}: UseCmsPagesQueryProps) => {
  const query = useQuery<CmsPage[]>({
    queryKey: CMS_PAGES_QUERY_KEY,
    queryFn: () => getCmsPages(accessToken ?? ""),
    enabled: enabled && !!accessToken,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      onGetCmsPagesSuccess();
    }
  }, [query.isSuccess, query.data, onGetCmsPagesSuccess]);

  useEffect(() => {
    if (query.isError) {
      onGetCmsPagesError();
    }
  }, [query.isError, onGetCmsPagesError]);

  return query;
};
